import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import "dayjs/locale/pt-br";
import dayjs from "dayjs";

type Props = {
  value: Date;
  setValue: (value: Date) => void;
  label?: string;
  disabled?: boolean;
  minTime?: Date;
  maxTime?: Date;
};

const DateTimePickerGeneric: React.FC<Props> = (props) => {
  const { value, setValue, label, disabled, minTime, maxTime } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DateTimePicker
        label={label ? label : "Escolha data e hora"}
        value={dayjs(value)}
        disabled={disabled}
        minTime={minTime ? dayjs(minTime) : undefined}
        maxTime={maxTime ? dayjs(maxTime) : undefined}
        onChange={(newValue) => {
          if (newValue) setValue(newValue.toDate());
        }}
        format="DD/MM/YYYY HH:mm"
        slotProps={{
          textField: { fullWidth: true },
        }}
      />
    </LocalizationProvider>
  );
};

export default DateTimePickerGeneric;
